import React, { useEffect } from "react";
import { Container, Grid } from "@mui/material";
import { connect } from "react-redux";
import accountActions from "../../../../actions/accountActions";
import { getSubscriptions } from "../../../../reducers";
import NoSubscriptions from "./NoSubscriptions";
import SubscriptionCard from "./SubscriptionCard";
import BreadcrumbBuilder from "../../../Common/Breadcrumbs/BreadcrumbBuilder";

function SubscriptionList({ subscriptions, getSubscriptions }) {
    useEffect(() => {
        getSubscriptions();
    }, [getSubscriptions]);

    return (
        <Container className="content">
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>
                {!subscriptions?.length ? (
                    <NoSubscriptions />
                ) : (
                    subscriptions.map((data) => (
                        <Grid item lg={12} xl={6} key={data.uuid}>
                            <SubscriptionCard data={data} />
                        </Grid>
                    ))
                )}
            </Grid>
        </Container>
    );
}

const mapStateToProps = (state) => ({
    subscriptions: getSubscriptions(state),
});

export default connect(mapStateToProps, {
    getSubscriptions: accountActions.getSubscriptions,
})(SubscriptionList);
